import generateKey from "./generateKey";

const MATCH_STRING = "script[src]";

/**
 * Monitors for new Scripts injected into the document and updates a Set
 * @param {Set} set
 */
export default function scriptObserver(set) {
    const moOptions = { childList: true };
    const mo = new MutationObserver(onMutation.bind(null, set));

    mo.observe(document.head, moOptions);
    mo.observe(document.body, moOptions);
}

/**
 * @param {Set} scriptsSet
 * @param {MutationRecord} mutations
 */
function onMutation(scriptsSet, mutations) {
    mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes).forEach((newNode) => {
            if (!(newNode.nodeType === 1 && newNode.matches(MATCH_STRING))) {
                return;
            }

            const key = generateKey(newNode.src);

            scriptsSet.add(key);
        });

        Array.from(mutation.removedNodes).forEach((oldNode) => {
            if (!(oldNode.nodeType === 1 && oldNode.matches(MATCH_STRING))) {
                return;
            }

            const key = generateKey(oldNode.src);

            scriptsSet.delete(key);
        });
    });
}
